<div class="flex flex-col space-y-6">
  <div class="flex justify-between items-center flex-col sbnbDesktop:flex-row">
    <h3 fxLayoutAlign="start center" fxLayoutGap="12px" class="not-clickable">
      <!-- <img src="/assets/iconography/calendar-upload.svg" class="img-icon" /> -->
      <span fxFlex>
        Imported iCals
        <span class="card__collapsed-helper-text">
          Import bookings from OTAs without an official connection to Hospitable.
        </span>
      </span>
    </h3>
    <sbnb-button
      label="Add External iCal"
      size="mini"
      type="secondary"
      (click)="openAddIcalDialog()"
      mat-flat-button></sbnb-button>
  </div>

  <div class="flex flex-col space-y-4">
    <div *ngIf="loading" class="text-center py-4">Loading iCal feeds...</div>

    <div *ngIf="!loading && icalFeeds.length === 0" class="text-center py-4 text-night-lighter">
      No iCal feeds added yet
    </div>

    <div
      *ngFor="let feed of icalFeeds"
      class="p-4 bg-white rounded-lg border border-smoke"
      data-element="ical-feed-item">
      <div class="flex items-center justify-between">
        <div>
          <h4 class="mb-1">{{ feed.name ?? feed.platform }}</h4>
          <div class="flex items-center space-x-2 flex-grow mr-4">
            <sbnb-icon-ical-platform [platform]="feed.platform"></sbnb-icon-ical-platform>
            <sbnb-truncate
              class="text-sm text-night-lighter max-w-96"
              [text]="feed.url.replace('https://', '').replace('www.', '')"></sbnb-truncate>
          </div>
        </div>
        <div class="flex items-center space-x-2">
          <span class="text-sm text-night-lighter">
            Last synced
            <span *ngIf="feed.last_synced_at">{{ feed.last_synced_at | timeAgo }}</span>
            <span *ngIf="!feed.last_synced_at">-</span>
          </span>
          <!-- Dropdown menu -->
          <div class="relative">
            <button
              (click)="toggleDropdown(feed.id)"
              class="p-2 text-night-lighter hover:text-primary rounded-full hover:bg-primary-lighter focus:outline-none dropdown-toggle">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
              </svg>
            </button>
            <div
              *ngIf="activeDropdown === feed.id"
              class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10 py-1 border border-smoke">
              <a
                (click)="editIcalFeed(feed)"
                class="block px-4 py-2 text-sm text-night hover:bg-smoke-lighter cursor-pointer"
                data-element="edit-ical-button">
                Edit
              </a>
              <a
                (click)="deleteIcalFeed(feed.id)"
                class="block px-4 py-2 text-sm text-rose-darker hover:bg-rose-lightest cursor-pointer"
                data-element="delete-ical-button">
                Delete
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
